import React from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Divider, Grid, Typography } from '@mui/material'
import { useNotifier } from '@cbgms/base/notifier'
import { IWholesalerCatalog } from '@cbgms/api'
import { useDispatch } from 'react-redux'
import { useQueryClient } from '@cbgms/base/http/use-query'
import { deleteWholesalerCatalog } from 'app-support/wholesale/state/actions'
import { wholesalerCatalogsCacheKey } from 'app-support/wholesale/hooks/cache-keys'
import { CatalogDetails } from 'app-support/wholesale/components/catalog/CatalogDetails'
import { VehicleSourceConfig } from 'app-support/wholesale/components/catalog/VehicleSourceConfig'

export const WholesalerCatalogDetails: React.FC<{ cat: IWholesalerCatalog | null; wholesalerUUID: string }> = ({ cat, wholesalerUUID }) => {
  const { t } = useTranslation()
  const { url } = useRouteMatch()
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const queryClient = useQueryClient()

  const onWholesalerCatalogDeleteClick = async () => {
    if (cat && wholesalerUUID) {
      await dispatch(deleteWholesalerCatalog(wholesalerUUID, cat.UUID))
      notifier.success(t('wholesaler-catalog.delete-success'))
      queryClient.invalidateQueries(wholesalerCatalogsCacheKey(wholesalerUUID))
    }
  }

  if (!cat) return null

  return (
    <>
      <Grid container justifyContent='space-between' spacing={1} data-testid='wholesaler-catalog-details-summary'>
        <Grid item>
          <Typography variant='h4' display='inline'>
            {t('wholesaler-catalog.label')}:{' '}
          </Typography>
          <Typography variant='h4' fontWeight='bold' display='inline'>
            {cat.CatalogType}
          </Typography>
        </Grid>
        <Grid item>
          <Grid container justifyContent='flex-end' spacing={1}>
            <Grid item>
              <Button size='small' onClick={onWholesalerCatalogDeleteClick} data-testid='unlink-catalog-button'>
                {t('wholesaler-catalog.unlink-button')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                size='small'
                color='primary'
                variant='contained'
                component={Link}
                to={`${url}/edit-catalog`}
                data-testid='edit-catalog-button'
              >
                {t('wholesaler-catalog.edit-button')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CatalogDetails cat={cat} />
      <Divider sx={{ mb: 2, mt: 2 }} />
      <VehicleSourceConfig cat={cat} />
    </>
  )
}
